export const FIT_SCALE_MIN = 0.5;
export const FIT_SCALE_MAX = 1.5;

/** Scale that makes a page of `pageWidth` fill `containerWidth`, clamped to a readable range. */
export function computeFitScale(containerWidth: number, pageWidth: number): number {
  if (containerWidth <= 0 || pageWidth <= 0) return FIT_SCALE_MIN;
  return Math.min(FIT_SCALE_MAX, Math.max(FIT_SCALE_MIN, containerWidth / pageWidth));
}
